import { EMPTY } from 'rxjs';
import { mergeMap, switchMap } from 'rxjs/operators';
import { IEpic, isTypeOf } from '@cbridge-utils/redux-observable';
import { addTokenToLocalStorage } from '../_helpers/localStorage';
import { initKeycloak } from '../_operators/initKeycloak';
import { IAuthDependencySegment } from '../_segments/IAuthDependencySegment';
import { AuthAction } from '../auth.action';

type IDependencies = IAuthDependencySegment;

export const loginEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOf(AuthAction.login),
  switchMap(() => {
    return initKeycloak(dependencies).pipe(
      mergeMap(({ authenticated }) => {
        if (authenticated) {
          const { token, tokenParsed, idTokenParsed, refreshToken } = dependencies.auth.getInstance();
          const { excludedScope } = dependencies.auth.getTokenExtras();

          if (import.meta.env.DEV) {
            addTokenToLocalStorage({ token, refreshToken });
          }

          return [
            AuthAction.loginDone({
              apiToken: token,
              apiTokenParsed: tokenParsed,
              idTokenParsed,
              excludedScope,
            }),
          ];
        }

        dependencies.auth.login();

        return EMPTY; // user is redirected to login page
      }),
    );
  }),
);
